import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing/TempLanding'; 
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import TodoList from './pages/Todos/TodoList';
import HomePage from './pages/Home/HomePage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login/>} />
      <Route path="/register" element={<Register/>} />
      <Route path="/home" element={<HomePage/>} />
      <Route path="/todolist" element={<TodoList/>} />
    </Routes>
  );
}

export default App;
